import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import DocumentsExportHistoryComponent from './DocumentsExportHistoryComponent';
import DocumentsUploadHistoryComponent from './DocumentsUploadHistoryComponent';
import { buildDMSDownloadUrl } from '../actionCreators';
import { DOCUMENT_HISTORY_QUERY } from '../queries';
import { useGlobalSubscription } from 'providers/GlobalCacheManager';
import { DOCUMENT_HISTORY_FOUND } from '../subscriptions';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import { FakeText } from '@totalsoft/rocket-ui';

const DocumentsExportHistoryContainer = ({ fileId, isForExport }) => {
  const [localDocumentHistory, setLocalDocumentHistory] = useState([]);
  const [documentHistoryLoaded, setDocumentHistoryLoaded] = useState(false);

  const { loading } = useQueryWithErrorHandling(DOCUMENT_HISTORY_QUERY, {
    variables: { fileId },
    fetchPolicy: 'network-only'
  });

  const downloadFile = useCallback(
    fileId => () => {
      async function downloadFileAsync() {
        try {
          let link = buildDMSDownloadUrl(fileId)();
          window.location = link;
        } catch (error) {
          // continue regardless of error
        }
      }
      downloadFileAsync();
    },
    []
  );

  useGlobalSubscription(DOCUMENT_HISTORY_FOUND, {
    variables: { fileId },
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      setLocalDocumentHistory(data.documentHistoryFound.list);
      setDocumentHistoryLoaded(true);
    }
  });

  const content = isForExport ? (
    <DocumentsExportHistoryComponent documentHistory={localDocumentHistory} downloadFile={downloadFile} />
  ) : (
    <DocumentsUploadHistoryComponent documentHistory={localDocumentHistory} downloadFile={downloadFile} />
  );

  return <>{loading || !documentHistoryLoaded ? <FakeText lines={6} /> : content}</>;
};

DocumentsExportHistoryContainer.propTypes = {
  fileId: PropTypes.string.isRequired,
  isForExport: PropTypes.bool
};

export default DocumentsExportHistoryContainer;
